(function () {
  'use strict';
  if (window.rdCardSwatches) { window.rdCardSwatches.refresh(); return; }
  var states = new WeakMap();
  var observed = new WeakSet();
  var frame = 0;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var tooltip = null;
  var tooltipButton = null;
  var tooltipTimer = 0;
  function hideTooltip() {
    window.clearTimeout(tooltipTimer);
    if (tooltip) tooltip.hidden = true;
    if (tooltipButton) {
      var ids = (tooltipButton.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
        return id && id !== 'rd-card-swatch-tooltip';
      });
      if (ids.length) tooltipButton.setAttribute('aria-describedby', ids.join(' '));
      else tooltipButton.removeAttribute('aria-describedby');
    }
    tooltipButton = null;
  }
  function showTooltip(button) {
    hideTooltip();
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'rd-card-swatch-tooltip';
      tooltip.className = 'rd-card-swatch-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltip);
    }
    tooltipButton = button;
    tooltip.textContent = button.dataset.rdOptionValue;
    tooltip.hidden = false;
    var box = button.getBoundingClientRect();
    var size = tooltip.getBoundingClientRect();
    var center = box.left + box.width / 2;
    var left = Math.max(8, Math.min(center - size.width / 2, document.documentElement.clientWidth - size.width - 8));
    var above = box.top - size.height - 8;
    tooltip.style.left = left + 'px';
    tooltip.style.top = (above >= 8 ? above : box.bottom + 8) + 'px';
    tooltip.dataset.side = above >= 8 ? 'above' : 'below';
    tooltip.style.setProperty('--rd-tooltip-arrow', Math.max(6, Math.min(center - left, size.width - 6)) + 'px');
    var ids = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    ids.push(tooltip.id);
    button.setAttribute('aria-describedby', ids.join(' '));
  }
  function tooltipTarget(target) {
    return target instanceof Element ? target.closest('.rd-card-swatch[data-rd-option-index]') : null;
  }
  function delayHideTooltip() {
    window.clearTimeout(tooltipTimer);
    tooltipTimer = window.setTimeout(hideTooltip, 150);
  }
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    if (tooltip && tooltip.contains(event.target)) { window.clearTimeout(tooltipTimer); return; }
    var button = tooltipTarget(event.target);
    if (button && !button.contains(event.relatedTarget)) showTooltip(button);
  });
  document.addEventListener('pointerout', function (event) {
    var button = tooltipTarget(event.target);
    if (button && !button.contains(event.relatedTarget)) delayHideTooltip();
    else if (tooltip && tooltip.contains(event.target) && !tooltip.contains(event.relatedTarget)) delayHideTooltip();
  });
  document.addEventListener('focusin', function (event) {
    var button = tooltipTarget(event.target);
    if (button) showTooltip(button);
  });
  document.addEventListener('focusout', function (event) {
    if (tooltipTarget(event.target)) hideTooltip();
  });
  document.addEventListener('scroll', hideTooltip, true);
  function imageFor(state, variant) {
    var image = state.data.images[variant.image];
    if (image) return image;
    var index = state.data.fabricIndex;
    // Accepted product behavior: a fabric photo on oak can illustrate other wood finishes.
    if (index >= 0) {
      var fallback = state.data.variants.find(function (item) {
        return item.options[index] === variant.options[index] && state.data.images[item.image];
      });
      return fallback ? state.data.images[fallback.image] : null;
    }
    return null;
  }
  function matchVariant(state, index, value) {
    var exact = state.data.variants.find(function (item) {
      return item.options[index] === value && item.options.every(function (option, i) {
        return i === index || option === (state.pending || state.variant).options[i];
      });
    });
    // Do not silently change another selected option to make an invalid combination work.
    return exact || null;
  }
  function variantURL(state, variant) {
    var url = new URL(state.data.url, window.location.origin);
    url.searchParams.set('variant', variant.id);
    return url.pathname + url.search;
  }
  function updateControls(state, showSelection) {
    state.root.querySelectorAll('[data-rd-option-index]').forEach(function (button) {
      var index = Number(button.dataset.rdOptionIndex);
      var variant = matchVariant(state, index, button.dataset.rdOptionValue);
      button.setAttribute('aria-pressed', String(showSelection && button.dataset.rdOptionValue === state.variant.options[index]));
      button.setAttribute('aria-disabled', String(!variant || !variant.available));
      if (variant) button.href = variantURL(state, variant);
    });
    var more = state.root.querySelector('[data-rd-swatch-more]');
    if (more) more.href = variantURL(state, state.variant);
  }
  function layout(root) {
    root.querySelectorAll('[data-rd-swatch-group]').forEach(function (group) {
      if (group.classList.contains('rd-card-swatches__group--fabric')) return;
      var track = group.querySelector('[data-rd-swatch-track]');
      var next = group.querySelector('[data-rd-swatch-next]');
      // Measure without the reserved arrow width first, avoiding layout oscillation.
      var available = group.clientWidth;
      var needed = track.scrollWidth;
      var overflow = needed > available + 1;
      group.classList.toggle('rd-card-swatches__group--overflow', overflow);
      next.hidden = !overflow;
    });
  }
  var resize = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  function refresh() {
    document.querySelectorAll('[data-rd-card-swatches]').forEach(function (root) {
      var state = states.get(root);
      if (!state) {
        var json = root.querySelector('[data-rd-card-variants]');
        try {
          var data = JSON.parse(json.textContent);
          var variant = data.variants.find(function (item) { return item.id === data.initial; }) || data.variants[0];
          // If the merchant's cover matches a variant photo, reflect that initial selection.
          var featured = data.variants.find(function (item) { return item.available && item.image === data.featured; });
          if (featured) variant = featured;
          state = { root: root, card: root.closest('.velaProBlock'), data: data, variant: variant, request: 0 };
          if (!state.card || !variant) return;
          states.set(root, state);
          updateControls(state, Boolean(featured));
        } catch (error) { return; }
      }
      if (resize && !observed.has(root)) { resize.observe(root); observed.add(root); }
      layout(root);
    });
  }
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(function () { frame = 0; refresh(); });
  }
  function preview(state, variant, image) {
    var token = ++state.request;
    state.pending = variant;
    var preload = new Image();
    state.root.setAttribute('aria-busy', 'true');
    preload.onload = function () {
      if (token !== state.request || !state.root.isConnected) return;
      var target = state.card.querySelector('.proFeaturedImage img');
      if (!target) { state.root.removeAttribute('aria-busy'); return; }
      ['data-src', 'data-srcset', 'srcset', 'data-widths', 'data-sizes'].forEach(function (name) { target.removeAttribute(name); });
      target.classList.remove('lazyload', 'lazyloading');
      target.classList.add('lazyloaded');
      target.src = image.src;
      target.alt = image.alt || '';
      state.variant = variant;
      state.pending = null;
      state.card.classList.add('rd-card-preview-active');
      var href = variantURL(state, variant);
      state.card.querySelectorAll('.proFeaturedImage, .proName a, a.btnAddToCart').forEach(function (link) { link.href = href; });
      updateControls(state, true);
      state.root.removeAttribute('aria-busy');
    };
    preload.onerror = function () {
      if (token === state.request) { state.pending = null; state.root.removeAttribute('aria-busy'); }
    };
    preload.src = image.src;
  }
  document.addEventListener('click', function (event) {
    var next = event.target.closest('[data-rd-swatch-next]');
    if (next) {
      var track = next.parentElement.querySelector('[data-rd-swatch-track]');
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      track.scrollTo({ left: end ? 0 : track.scrollLeft + track.clientWidth * .8, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      return;
    }
    var button = event.target.closest('[data-rd-option-index]');
    if (!button || !button.closest('[data-rd-card-swatches]')) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var root = button.closest('[data-rd-card-swatches]');
    var state = states.get(root);
    if (!state) return; // Native variant link remains usable before enhancement.
    var variant = matchVariant(state, Number(button.dataset.rdOptionIndex), button.dataset.rdOptionValue);
    if (!variant || !variant.available) { event.preventDefault(); return; }
    var image = imageFor(state, variant);
    if (!image) return; // No matching photo: open the selected product variant instead.
    event.preventDefault();
    preview(state, variant, image);
  }, true); // Handle sample clicks before legacy card/app bubbling handlers.
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hideTooltip();
    var button = event.target.closest('.rd-card-swatch');
    if (button && event.key === ' ') { event.preventDefault(); button.click(); }
  });
  window.addEventListener('resize', function () { hideTooltip(); schedule(); });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return record.addedNodes.length > 0; })) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.rdCardSwatches = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();

